// extracted by mini-css-extract-plugin
export var measureBox = "_1e-0";